export default __webpack_public_path__ + "static/media/view_all-btn.d4e4dbe4.svg";